import { toast } from "vue-sonner";

export function unreadNotificationsToast(count: number, onClick: () => void) {
	const message =
		count === 1
			? "Je hebt 1 ongelezen notificatie"
			: `Je hebt ${count} ongelezen notificaties`;

	toast.info(message, {
		action: { label: "Bekijk", onClick },
	});
}
